import { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import { IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Iconify from '@/components/iconify/Iconify';
import { fCurrency, fPercent } from '@/utils/formatNumber';

PaymentMethodsTable.propTypes = {
  data: PropTypes.array,
  fetching: PropTypes.bool,
};

function PaymentMethodsTable({ data, fetching }) {
  const [showValues, setShowValues] = useState(true);


  useEffect(() => {
    if (!fetching && data?.length) {
      setShowValues(true);
    }
  }, [data, fetching]);

  return (
    <>
      {fetching ? <LinearProgress sx={{ position: 'absolute', top: 0, left: 0, width: '100%' }} /> : <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Meios de Pagamento</TableCell>
              <TableCell>Conversão</TableCell>
              <TableCell>Valor <IconButton onClick={() => setShowValues(!showValues)} edge="end">
                <Iconify
                  width={20}
                  icon={showValues ? 'eva:eye-fill' : 'eva:eye-off-fill'}
                />
              </IconButton></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                <TableCell sx={{ display: 'flex' }}>
                  <Iconify icon={row.icon} width={25} height={25} sx={{ marginRight: 2 }} />{row.title}
                </TableCell>
                <TableCell>{fPercent(row.approvalRate || 0)}</TableCell>
                <TableCell sx={{ filter: showValues ? 'none' : 'blur(12px)' }}>{fCurrency(row.amount || 0)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      }
    </>
  );
}

export default PaymentMethodsTable;
